






import { defineComponent } from '@vue/composition-api';

import { withLoadingSpinner } from '@src/app/utils/withLoadingSpiner';

export default defineComponent({
    setup() {
        return {
            continueComponent: withLoadingSpinner(() => import('@accountFederation/countries/be/registration/ContinueRegistration.vue')),
        };
    },
});
